import { liberisAgreementsNames, prefixedAgreementsNames, providerType } from '@repo/shared/types';
import { MerchantDataPayload } from '@repo/api/endpoints/merchant';
import { LiberisStage } from '@repo/app-contexts/liberis';
import { hasProviderAnyLoanFinished } from '@repo/store/helpers';

const agreementsFields = [
  liberisAgreementsNames.enum['agreements.bureau'],
  liberisAgreementsNames.enum['agreements.liberisDataToPayPro'],
  liberisAgreementsNames.enum['agreements.payProToLiberisData'],
];

const regularPragmaAgreementsFields = [
  prefixedAgreementsNames.enum['pragmaAgreements.representative'],
  prefixedAgreementsNames.enum['pragmaAgreements.loanTerms'],
  prefixedAgreementsNames.enum['pragmaAgreements.payProDataProcessing'],
  prefixedAgreementsNames.enum['pragmaAgreements.pragmaGoDataProcessing'],
];

const noLoanPragmaAgreements = [
  prefixedAgreementsNames.enum['pragmaAgreements.pragmaTerms'],
  prefixedAgreementsNames.enum['pragmaAgreements.bikbig'],
];

const pragmaAgreementsFields = (data: MerchantDataPayload) => {
  if (!hasProviderAnyLoanFinished(providerType.enum.pragma, data)) {
    return [...regularPragmaAgreementsFields, ...noLoanPragmaAgreements];
  }

  return regularPragmaAgreementsFields;
};

const amountFields = ['amount'];

const representativeDataFields = (activeBeneficientIndex: number) => [
  `person[${activeBeneficientIndex}].phone`,
  `person[${activeBeneficientIndex}].email`,
  `person[${activeBeneficientIndex}].address.postCode`,
  `person[${activeBeneficientIndex}].address.city`,
  `person[${activeBeneficientIndex}].address.street`,
  `person[${activeBeneficientIndex}].address.country`,
];

const beneficientDataFields = (activeBeneficientIndex: number) => [
  ...representativeDataFields(activeBeneficientIndex),
  `person[${activeBeneficientIndex}].shares`,
  `person[${activeBeneficientIndex}]`,
];

const companyDataFields = [
  'merchantData.address.street',
  'merchantData.address.postCode',
  'merchantData.address.city',
  'merchantData.address.country',
  'ibanId',
  'companyRegisterDate',
];

export const formStepsFields: Record<
  LiberisStage,
  | string[]
  | ((activeBeneficientIndex: number) => string[])
  | ((data: MerchantDataPayload) => string[])
> = {
  AMOUNT: amountFields,
  AGREEMENTS: agreementsFields,
  AGREEMENTS_PRAGMA: pragmaAgreementsFields,
  BENEFICIENT_DATA: beneficientDataFields,
  COMPANY_DATA: companyDataFields,
  CHECK_YOUR_DATA: [],
};
